/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_TagsInputs */

const en_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const de_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const fr_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const es_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const it_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const nl_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const pl_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const fi_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const da_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

const sv_story_bank_label_tags = /** @type {(inputs: Story_Bank_Label_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags (comma-separated)`)
};

/**
* | output |
* | --- |
* | "Tags (comma-separated)" |
*
* @param {Story_Bank_Label_TagsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_tags = /** @type {((inputs?: Story_Bank_Label_TagsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_TagsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_tags(inputs)
	if (locale === "fr") return fr_story_bank_label_tags(inputs)
	if (locale === "es") return es_story_bank_label_tags(inputs)
	if (locale === "it") return it_story_bank_label_tags(inputs)
	if (locale === "nl") return nl_story_bank_label_tags(inputs)
	if (locale === "pl") return pl_story_bank_label_tags(inputs)
	if (locale === "fi") return fi_story_bank_label_tags(inputs)
	if (locale === "da") return da_story_bank_label_tags(inputs)
	if (locale === "sv") return sv_story_bank_label_tags(inputs)
	return en_story_bank_label_tags(inputs)
});